<!-- Single Tabs -->
<div *ngIf="!sidebarMenu.submenu">
  <a
    class="nav-link"
    *ngxPermissionsOnly="sidebarMenu.permissions"
    [routerLink]="sidebarMenu.path"
    [routerLinkActiveOptions]="{ exact: true }"
    routerLinkActive="active"
    [ngbTooltip]="barIsCollapsed ? sidebarMenu.description : null"
    container="body"
    placement="right">
    <i [class]="sidebarMenu.icon"></i>
    <span [hidden]="barIsCollapsed">{{ sidebarMenu.description }}</span>
  </a>
</div>
<!-- Nested Tabs -->
<div *ngIf="permissionsLoaded && sidebarMenu.submenu">
  <!-- Expanded: Accordion behavior -->
  <div *ngIf="!barIsCollapsed">
    <div
      class="nav-link nest-header"
      *ngxPermissionsOnly="sidebarMenu.permissions"
      [ngClass]="{
        active: highlightParent,
        opened: activeNav === sidebarMenu.path
      }"
      (click)="toggleNavStatusActiveNav()">
      <i [class]="sidebarMenu.icon" [title]="sidebarMenu.description"></i>
      <span>{{ sidebarMenu.description }}</span>
      <i
        class="toggle-icon fas fa-angle-down"
        [ngClass]="{ opened: activeNav === sidebarMenu.path }">
      </i>
    </div>
    <!-- Sub-menu accordion -->
    <ul [ngbCollapse]="activeNav !== sidebarMenu.path">
      <li *ngFor="let tab of sidebarMenu.submenu">
        <div *ngIf="tab.isSectionLabel" class="sub-menu-section-label">{{ tab.description }}</div>
        <ng-container *ngIf="!tab.isSectionLabel && tab.path">
          <a
            class="nav-link sub-menu"
            *ngxPermissionsOnly="tab.permissions"
            [routerLink]="tab.path"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="active">
            {{ tab.description }}
          </a>
        </ng-container>
        <ng-container *ngIf="!tab.isSectionLabel && tab.action">
          <a
            class="nav-link sub-menu"
            *ngxPermissionsOnly="tab.permissions"
            (click)="menuAction(tab.action)">
            {{ tab.description }}
          </a>
        </ng-container>
      </li>
    </ul>
  </div>

  <!-- Collapsed: Flyout dropdown on hover -->
  <ng-container *ngxPermissionsOnly="sidebarMenu.permissions">
    <div
      *ngIf="barIsCollapsed"
      ngbDropdown
      #d="ngbDropdown"
      class="sidebar-collapsed-dropdown"
      container="body"
      display="dynamic"
      placement="right-top"
      (mouseenter)="openOnHover(d)"
      (mouseleave)="scheduleClose(d)">
      <!-- The menu header IS the toggle -->
      <div
        class="nav-link nest-header text-center"
        [ngClass]="{ active: highlightParent }"
        ngbDropdownToggle>
        <i [class]="sidebarMenu.icon"></i>
      </div>

      <!-- Flyout menu -->
      <div
        ngbDropdownMenu
        class="sidebar-flyout-menu"
        (mouseenter)="cancelClose()"
        (mouseleave)="scheduleClose(d)">
        <h6 class="dropdown-header">{{ sidebarMenu.description }}</h6>

        <ng-container *ngFor="let tab of sidebarMenu.submenu">
          <div *ngIf="tab.isSectionLabel" class="dropdown-subheader">{{ tab.description }}</div>
          <ng-container *ngIf="!tab.isSectionLabel">
            <ng-container *ngxPermissionsOnly="tab.permissions">
              <button
                *ngIf="tab.path"
                type="button"
                ngbDropdownItem
                [routerLink]="tab.path"
                [routerLinkActiveOptions]="{ exact: true }"
                routerLinkActive="active"
                (click)="d.close()">
                {{ tab.description }}
              </button>

              <button
                *ngIf="tab.action"
                type="button"
                ngbDropdownItem
                (click)="menuAction(tab.action); d.close()">
                {{ tab.description }}
              </button>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>
